import React, { FC, useState } from 'react';
import { Button } from '@mui/material';
import { AgentRequestResponse } from '../../structures/response/AgentRequestResponse';
import { feedbackSend } from '../../api/agent';

interface Props {
  data: AgentRequestResponse | null;
}

const ConsultationForm: FC<Props> = ({ data }: Props) => {
  const [processing, setProcessing] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);

  if (!data) {
    return null;
  }

  const sendConsultingRequest = async () => {
    if (processing) {
      return false;
    }
    setProcessing(true);
    try {
      const message = `
      Запрос консультации
      Агентский запрос №${data.id}.
    `;
      await feedbackSend(message);
    } catch (e) {
      console.log(e); // todo: remove this line
    }
    setProcessing(false);
    setSent(true);
    return true;
  };

  if (sent) {
    return (
      <div>
        <p>Благодарим за обращение.</p>
        <p>
          Мы свяжемся с Вами в ближайшее время и ответим на все интересующие
          вопросы.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div>
        Если у вас возникли вопросы относительно порядка инвестирования,
        получите нашу консультацию.
      </div>
      <div>Специалист Money Friends свяжется с вами в ближайшее время.</div>
      <div>
        <Button
          sx={{ mt: 3 }}
          variant="contained"
          disabled={processing}
          onClick={sendConsultingRequest}
        >
          Получить консультацию по запросу №{data.id}
        </Button>
      </div>
    </div>
  );
};

export default ConsultationForm;
